export default "__VITE_ASSET__C7wY0inJ__"